import React, { useEffect, useRef, useState } from 'react';
import { Badge } from 'react-bootstrap';
import Select, { components as RsComponents } from 'react-select';
import styles from '../../SelectComponents.module.css';

const CheckboxOption = (props) => (
	<RsComponents.Option {...props}>
		<div style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
			<input
				type={props.selectProps.isSingle ? 'radio' : 'checkbox'}
				checked={props.isSelected}
				onChange={() => null}
				style={{ cursor: 'pointer', flexShrink: 0 }}
			/>
			{props.data.color && (
				<span style={{
					display: 'inline-block',
					width: '10px',
					height: '10px',
					borderRadius: '50%',
					backgroundColor: props.data.color,
					flexShrink: 0,
				}} />
			)}
			{props.data.image && (
				<img src={props.data.image} className={styles.image} alt="" />
			)}
			<div className={styles.infoContainer}>
				{props.data.label}
				{props.data.description && props.data.description !== '' && (
					<span className={styles.description}>{props.data.description}</span>
				)}
			</div>
		</div>
	</RsComponents.Option>
);

const DashboardFilterDropdown = ({ label, filterKey, options, value, onChange, isLoading, single, onOpenChange }) => {
	const [show, setShow] = useState(false);
	const [openLeft, setOpenLeft] = useState(false);
	const ref = useRef(null);
	const selectRef = useRef(null);
	const closeReasonRef = useRef(null);

	useEffect(() => {
		if (show) {
			setTimeout(() => selectRef.current?.focus(), 10);
			closeReasonRef.current = null;
		}
		onOpenChange?.(show, closeReasonRef.current);
		closeReasonRef.current = null;
	}, [show]);

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (ref.current && !ref.current.contains(e.target)) {
				closeReasonRef.current = 'outside';
				setShow(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const activeCount = Array.isArray(value) ? value.length : 0;
	const selectedValue = options.filter(o => Array.isArray(value) && value.includes(o.value));
	// For single-select, react-select expects an object or null (not an array)
	const singleValue = single ? (selectedValue[0] ?? null) : undefined;

	const handleChange = (selected) => {
		if (single) {
			// If the clicked option is already selected, deselect it
			const newValue = singleValue && selected?.value === singleValue.value ? null : selected?.value ?? null;
			onChange(filterKey, newValue);
			closeReasonRef.current = 'deliberate';
			setShow(false);
		} else {
			onChange(filterKey, selected ? selected.map(s => s.value) : []);
		}
	};

	return (
		<div ref={ref} className="position-relative d-inline-block">
			<button
				data-filter-toggle="true"
				className={`btn d-flex align-items-center gap-1 ${activeCount > 0 ? 'btn-primary' : 'btn-secondary'}${show ? ' show' : ''}`}
				style={{ fontSize: '14px', whiteSpace: 'nowrap' }}
				onClick={() => {
					if (!show && ref.current) {
						const rect = ref.current.getBoundingClientRect();
						setOpenLeft(rect.left + 230 > window.innerWidth);
					}
					if (show) closeReasonRef.current = 'deliberate';
					setShow(s => !s);
				}}
				disabled={isLoading}
			>
				{single && singleValue ? (
					<>
						{singleValue.image && (
							<img src={singleValue.image} style={{ width: '18px', height: '18px', borderRadius: '50%', flexShrink: 0 }} alt="" />
						)}
						{singleValue.label}
					</>
				) : label}
				{!single && activeCount > 0 && (
					<Badge bg="light" text="dark" style={{ fontSize: '11px' }}>{activeCount}</Badge>
				)}
				<span className="ms-1" style={{ display: 'inline-block', width: 0, height: 0, borderLeft: '4px solid transparent', borderRight: '4px solid transparent', borderTop: '4px solid currentColor', verticalAlign: 'middle' }} />
			</button>
			{show && (
				<div
					className="position-absolute bg-white border rounded shadow-sm p-2"
					style={{ zIndex: 1050, top: '100%', left: openLeft ? 'auto' : 0, right: openLeft ? 0 : 'auto', minWidth: '230px', marginTop: '4px' }}
					onMouseDown={(e) => e.stopPropagation()}
				>
					<Select
						ref={selectRef}
						menuIsOpen
						isMulti={!single}
						isClearable={false}
						closeMenuOnSelect={single}
						hideSelectedOptions={false}
						options={options}
						value={single ? singleValue : selectedValue}
						components={{ Option: CheckboxOption, IndicatorsContainer: () => null, ...(single && { SingleValue: () => null }) }}
						isSingle={single}
						placeholder={`Search ${label}...`}
						onChange={handleChange}
						classNamePrefix="select-component"
						styles={{
							control: (base) => ({ ...base, fontSize: '13px', minHeight: '32px', marginBottom: '4px' }),
							menu: (base) => ({ ...base, position: 'static', boxShadow: 'none', border: 'none', margin: 0 }),
							menuList: (base) => ({ ...base, maxHeight: '220px', padding: 0 }),
							multiValue: () => ({ display: 'none' }),
							option: (base) => ({ ...base, textAlign: 'left' }),
							placeholder: (base) => ({ ...base, fontSize: '13px', color: '#999' }),
						}}
					/>
					{activeCount > 0 && (
						<button className="btn btn-sm btn-link text-danger p-0 mt-1" style={{ fontSize: '12px' }} onClick={() => onChange(filterKey, single ? null : [])}>
							Clear
						</button>
					)}
				</div>
			)}
		</div>
	);
};

export default DashboardFilterDropdown;
